import React from 'react';
import { photos, processSteps } from '../data/site';
export function Process() {
  return <section className="bg-paper py-24" data-id="element-228" data-mp="1ud3r2rcpihpj">
      <div className="mx-auto grid max-w-[1240px] items-center gap-16 px-6 lg:grid-cols-2" data-id="element-229" data-mp="1uc24pqq8q8si">
        <div className="aspect-square w-full overflow-hidden border border-line" data-id="element-230" data-mp="1ygi55ch34o0c">
          <img src={photos.clipboard} alt="Two advisors reviewing an engagement checklist in an office" className="h-full w-full object-cover" data-id="element-231" data-mp="23d8me34mlpnc" />
        </div>

        <div data-id="element-232" data-mp="1aqntgy8i55ho">
          <p className="eyebrow text-green-dark" data-id="element-233" data-mp="1aq5ptgjifozq">How It Works</p>
          <h2 className="mt-5 font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-234" data-mp="1foh17vpge7k2">
            Our process for a sound financial outcome
          </h2>
          <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-235" data-mp="n0l4iqzvwfna" />

          <ol className="mt-10" data-id="element-236" data-mp="rz4rmuq7rxh8">
            {processSteps.map(step => <li key={step.index} className="flex gap-6 border-t border-line py-7 last:border-b" data-id="element-237" data-mp="rx1y40purm7r">
                <span className="font-mono text-[12px] text-green-dark" data-id="element-238" data-mp="15jdygghikirz">{step.index}</span>
                <div data-id="element-239" data-mp="10se4nk3oygtp">
                  <h3 className="font-display text-[20px] text-ink" data-id="element-240" data-mp="10rmggucfbldg">{step.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-70" data-id="element-241" data-mp="vum7obo6w4in">
                    {step.description}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}